import React, { useEffect, useState } from "react"
import { Dimensions, ScrollView, View } from "react-native"
import CustomBottomModal from "@Components/Modal/CustomBottomModal/CustomBottomModal"
import { RFValue } from "react-native-responsive-fontsize"
import { Button } from "@Components/CustomButton/Button"
import { baseColors } from "@Constants/baseStyles"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { Spacer } from "@Components/Space"
import { InputGroup } from "@Components/Input/InputGroups"
import { FeedbackService } from "@Services/FeedBack.Service"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"

const { width, height } = Dimensions.get("screen")
export const ModalCreateFeedBack = (props) => {
    const { toggleModal, openModal, feedbackType } = props
    const minLength = 3
    const defaultFeedback = {
        title: "",
        message: "",
        typeId: feedbackType?.id
    }
    const [saving, setSaving] = useState(false)
    const [feedback, setFeedback] = useState(defaultFeedback)
    const disableCreationBtn = feedback.message.length < minLength || feedback.title.length < minLength
    const performCreateFeedback = () => {
        setSaving(true)
        FeedbackService.create(feedback)
            .then((response) => {
                const data = response.data?.data
                setSaving(false)
                setFeedback(defaultFeedback)
                toggleModal?.(false)
                ShowToast({ type: "success", message: "Création du feedback réussie" })
            })
            .catch((e) => {
                console.log({ e })
                setSaving(false)
                ShowToast({
                    type: "error",
                    message: "Oups, une erreur est survenue lors de la création de votre feedback"
                })
            })
    }

    useEffect(() => {
        if (feedbackType?.id) {
            setFeedback((old) => ({ ...old, typeId: feedbackType?.id }))
        }
    }, [feedbackType])

    return (
        <CustomBottomModal
            permanent
            disabled={saving}
            toggleModal={() => {
                toggleModal?.(false)
                setFeedback(defaultFeedback)
            }}
            open={openModal}
            footer={
                <Button
                    disabled={disableCreationBtn || saving}
                    loading={saving}
                    onPress={performCreateFeedback}
                    text="Valider"
                    width="70%"
                    backgroundColor={baseColors.green.primary}
                    labelColor={"white"}
                />
            }
        >
            <View style={{ height: "80%" }}>
                <BreeSerifText textAlign={"center"} fontSize={RFValue(23)} color={baseColors.black}>
                    {feedbackType?.name}
                </BreeSerifText>

                <Spacer />

                <InputGroup
                    disabled={saving}
                    validation_message="Champ obligatoire"
                    placeholder="Exemple : diagnostic éducatif"
                    value={feedback.title}
                    onChange={(txt) =>
                        setFeedback((old) => ({
                            ...old,
                            title: txt
                        }))
                    }
                    valid={feedback.title.length > minLength}
                    label={"Titre"}
                />

                <InputGroup
                    multiline
                    disabled={saving}
                    height={100}
                    validation_message="Champ obligatoire"
                    placeholder="Tapez votre message ..."
                    value={feedback.message}
                    onChange={(txt) =>
                        setFeedback((old) => ({
                            ...old,
                            message: txt
                        }))
                    }
                    valid={feedback.message.length > minLength}
                    label={"Message"}
                />
            </View>
        </CustomBottomModal>
    )
}
